module.exports = __webpack_public_path__ + "static/img/about.670f3d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about.png
// module id = xWQz
// module chunks = 6